/* eslint-disable jsx-a11y/label-has-associated-control */

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import {
    Box,
    Card,
    Grid,
    Container,
    CardContent,
    CardActions,
    Typography,
} from "@mui/material";

import useForm from "../../hooks/validation";
import { styles } from "./style";
import Iconify from "../../components/iconify/iconify";
import LoadingButton from "../../shared/loadingButton/LoadingButton";
import { placeholderStye } from "../../theme/style";
import MuiTextField from "../../theme/TextField";
import { getErrorMessage } from "../../utils";
import tributeServices from "../../services/tributeServices";
import RichTextEditor from "../../components/RichTextEditor";

const initialValues = {
    description: "",
    short_description: "",
};

const validationRules = {
    description: (value) => (value ? "" : "This field is required"),
    short_description: (value) => (value ? "" : "This field is required"),

};
const CreateTribute = () => {
    const navigate = useNavigate();

    const { values, errors, handleOnChange, validateAllFields } =
        useForm(initialValues, validationRules);

    const [memberImage, setMemberImage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];


        setMemberImage(file);
    };

    const handleRichTextChange = (content, fieldName) => {
        handleOnChange({ target: { name: fieldName, value: content } });
    };

    const handleSubmit = async () => {
        if (!memberImage || !(memberImage instanceof File)) {
            toast.error("Image is required");
            return;
        }
        const formData = new FormData();
        formData.append("description", values.description ?? "");
        formData.append("shortStatement", values.short_description ?? "");
        formData.append("image", memberImage);

        if (validateAllFields()) {
            setIsLoading(true);
            tributeServices
                .create(formData)
                .then(() => {
                    toast.success("Created Successfully");
                    navigate(-1);
                    setIsLoading(false);
                })
                .catch((err) => {
                    toast.error(getErrorMessage(err));
                    setIsLoading(false);
                });
        }
    };

    return (
        <Container>
            <Card sx={{ padding: "1rem" }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box sx={{ ...styles.mainWrapper, ...(!memberImage && { maxWidth: "100%", width: "100%" }) }}>
                                <input
                                    type="file"
                                    name="staffProfileImage"
                                    id="staff_profile_img"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                {memberImage ? (
                                    <Box sx={styles.imagePreviewBlock}>
                                        <Box sx={styles.imageWrapper}>
                                            <Box sx={{ width: "100%", height: "100%" }}>
                                                <img
                                                    height="100%"
                                                    width="100%"
                                                    style={{ objectFit: "cover" }}
                                                    src={URL.createObjectURL(memberImage)}
                                                    alt="Tribute"
                                                />
                                            </Box>
                                        </Box>
                                        <label htmlFor="staff_profile_img">
                                            <Typography
                                                component="span"
                                                variant="caption"
                                                sx={styles.changeImageLink}
                                            >
                                                <Iconify icon="eva:edit-2-outline" sx={{ width: 14, height: 14, mr: 0.5, verticalAlign: "middle" }} />
                                                Change image
                                            </Typography>
                                        </label>
                                    </Box>
                                ) : (
                                    <label
                                        htmlFor="staff_profile_img"
                                        style={{ cursor: "pointer", display: "block" }}
                                    >
                                        <Box sx={[styles.imageWrapper, styles.imageWrapperEmpty]}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                Click here
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    mt: 0.5,
                                                }}
                                            >
                                                to add image
                                            </Typography>
                                        </Box>
                                    </label>
                                )}
                            </Box>
                        </Grid>

                        {/* <Grid item xs={12}>
                            <MuiTextField
                                label="name"
                                name="name"
                                value={values.name}
                                error={errors.name}
                                helperText={errors.name}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="Name"
                            />
                        </Grid> */}
                        <Grid item xs={12}>
                            <MuiTextField
                                label="short description"
                                name="short_description"
                                value={values.short_description}
                                error={errors.short_description}
                                helperText={errors.short_description}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="short description"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <RichTextEditor
                                label="Description"
                                value={values.description}
                                onChange={(content) => handleRichTextChange(content, "description")}
                                error={errors.description}
                                placeholder="Enter detailed description"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <LoadingButton
                        isLoading={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Add Tribute
                    </LoadingButton>
                </CardActions>
            </Card>
        </Container>
    );
};

export default CreateTribute;
